/*
 * @Author: cgh
 * @Date: 2022-08-01 10:49:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-02 09:58:15
 * @Description: 评估项目的评估人员
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const pgcyService = {

  // 评估成员列表查询
  pgcyQuery: (id, params) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/pgcy`, { params: params }); },

  // 添加评估成员
  addPgcy: (id, fd) => { return axios.post(`${iffApi}/xfpg/pgxm/${id}/pgcy`, fd); },

  // 删除评估成员
  delPgcy: (id, pgid) => { return axios.delete(`${iffApi}/xfpg/pgxm/${id}/pgcy/${pgid}`); },

  // 修改评估成员
  updatePgcy: (id, fd) => { return axios.put(`${iffApi}/xfpg/pgxm/${id}/pgcy`, fd); }

  // // 添加时获取评估成员列表
  // getPgcyList: (roleCode) => { return axios.get(`${this.$config.commontCtx}/roleCapacity/role/${roleCode}/capacities`); }

};
